<template>
  <div class="elite-tabs-wrapper-content">
    <log-list-table :filterSubject="paymentMethod" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "payment-method-view-logs",

  components: { LogListTable },

  props: ["paymentMethod"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
